import styled from 'styled-components'

export const Main = styled.header`
  * { box-sizing: border-box; }

  position: fixed;
  top: 0;
  right: 0;
  left: ${({ $openMenu }) => $openMenu ? '256px' : '64px'};
  height: 64px;
  background: white;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  z-index: 110;
  display: flex;
  align-items: center;
  padding: 0 32px 0 20px;
  transition: left 200ms cubic-bezier(.4,0,.2,1);

  @media (width <= 1200px) {
    left: 0 !important;
  }
`

export const HamburgerButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--vo-slate);
  flex-shrink: 0;

  &:hover {
    background: var(--vo-mist);
  }
`

export const TenantChip = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: var(--vo-warning-10);
  border: 1px solid var(--vo-warning);
  border-radius: 8px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--vo-warning);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`

export const NotifBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: var(--vo-danger);
  border: 2px solid white;
  color: white;
  font-size: 9px;
  font-weight: 700;
  font-family: 'Maven Pro', sans-serif;
  display: ${({ $show }) => $show ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  padding: 0 3px;
`

export const UserButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px 5px 5px;
  border-radius: 10px;
  border: 1px solid var(--vo-line);
  background: white;
  cursor: pointer;

  &:hover {
    background: var(--vo-mist);
  }
`

export const UserInitialsAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
`

export const UserName = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink-2);
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const UserDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 260px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 8px 24px color-mix(in srgb, var(--vo-escuro) 12%, transparent);
  z-index: 1000;
  overflow: hidden;
  display: ${({ $open }) => $open ? 'block' : 'none'};
`

export const DropdownUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--vo-cloud);
`

export const DropdownUserAvatar = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
`

export const DropdownUserMeta = styled.div`
  flex: 1;
  min-width: 0;

  .name {
    font-family: 'Maven Pro', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: var(--vo-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .email {
    font-family: 'Lato', sans-serif;
    font-size: 12px;
    color: var(--vo-slate);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 1px;
  }
`

export const CompanySelectWrapper = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid var(--vo-cloud);
`

export const CompanySelectLabel = styled.label`
  display: block;
  font-family: 'Maven Pro', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: var(--vo-slate);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
`

export const LogoutItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: white;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-danger);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: var(--vo-danger-10);
  }
`

export const TenantBanner = styled.div`
  position: fixed;
  left: ${({ $openMenu }) => $openMenu ? '256px' : '64px'};
  top: 64px;
  right: 0;
  height: 48px;
  background: var(--vo-warning-10);
  border-bottom: 2px solid var(--vo-warning);
  z-index: 98;
  display: flex;
  align-items: center;
  padding: 0 32px;
  gap: 10px;
  transition: left 200ms cubic-bezier(.4,0,.2,1);

  @media (width <= 1200px) {
    left: 0 !important;
  }
`

export const BannerText = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--vo-warning);
`

export const BannerSub = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  color: var(--vo-warning);
  opacity: 0.8;
`

export const BannerBackButton = styled.button`
  margin-left: auto;
  background: white;
  border: 1px solid var(--vo-warning);
  border-radius: 8px;
  padding: 5px 14px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--vo-warning);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: var(--vo-heatmap-risky);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const NotificationDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 320px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 8px 24px color-mix(in srgb, var(--vo-escuro) 12%, transparent);
  z-index: 1000;
  overflow: hidden;
  display: ${({ $open }) => $open ? 'block' : 'none'};
`

export const NotifDropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
  border-bottom: 1px solid var(--vo-cloud);

  .title {
    font-family: 'Maven Pro', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: var(--vo-ink);
  }

  .count {
    font-family: 'Maven Pro', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: var(--vo-slate);
  }
`
